module.exports = __webpack_public_path__ + "4b6d169bc0dc6fa2de74ed23154136fe.png";